import StoreFirebaseModel from './StoreFirebaseModel';

export default class StoreTicket extends StoreFirebaseModel {

}

StoreTicket.collection = 'tickets';

// Round.addListener((datas) => { alert(`update ${datas.length}`) })
// Round.add({ test: true })
// Round.getItems();